// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cN36O","colBig":"styles_colBig__32OfB","colSmall":"styles_colSmall__5McJq"};